// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d04580a6","667":"7275ad6f"}[chunkId] + ".chunk.js";
};